import styled from 'styled-components'

const H2 = styled.h2`
  font-family: 'Montserrat', sans-serif;
  margin: 0;
  font-size: 1.7em;
`
export default H2
